









































































































































import BillingProduct from '@/datatypes/billing/product';
import BillingPrice from '@/datatypes/billing/price';
import BillingProductService from '@/services/billing/BillingProductService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    billingProduct: new BillingProduct({}),
    billingPrices: new Array<BillingPrice>(),
    billingProductService: new BillingProductService(),
    errorMessage: '',
    nextPointer: undefined as undefined | string,
    showInactive: false,
    subscriptionSchemeOption: 'v2',
    pricesListed: false,
    isChangingEditable: false,
    showLegacy: false,
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getBillingProduct();
    },

    requestNextPage() {
      this.getBillingPrices();
    },

    resetPriceList() {
      this.billingPrices = new Array<BillingPrice>();
    },

    resetPointer() {
      this.nextPointer = undefined;
    },

    switchEditable(value) {
      this.billingProductService.update(
        this.billingProduct.id, {
          editable: value,
        },
      ).then(() => {
        this.errorMessage = 'Product updated.';
        this.getBillingProduct();
        this.isChangingEditable = false;
      });
    },

    getBillingPrices() {
      this.billingProductService.listPrices(
        this.billingProduct.id, this.priceOptions,
      ).then(
        (prices) => {
          this.billingPrices = this.billingPrices.concat(
            prices.data.map(
              (data) => new BillingPrice(camelcaseKeysDeep(data)),
            ),
          );

          this.pricesListed = true;

          if (prices.headers.next) {
            this.nextPointer = prices.headers.next;
          } else {
            this.nextPointer = undefined;
          }
        },
      );
    },

    getBillingProduct() {
      const billingProductId = this.$route.params.id;

      this.billingProductService.show(billingProductId).then((response) => {
        this.billingProduct = new BillingProduct(camelcaseKeysDeep(response.data));

        this.getBillingPrices();
      });
    },

    switchInactive(value) {
      this.resetPriceList();
      this.resetPointer();
      this.showInactive = value;
      this.getBillingPrices();
    },

    switchLegacy() {
      this.resetPriceList();
      this.resetPointer();
      if (this.subscriptionSchemeOption === 'v2') {
        this.subscriptionSchemeOption = 'legacy';
        this.showLegacy = true;
      } else {
        this.subscriptionSchemeOption = 'v2';
        this.showLegacy = false;
      }
      this.getBillingPrices();
    },

    priceMetadataText(metadata): string {
      const values = [
        metadata.quota, metadata.quotaRenewal, metadata.smsUnitAmount,
      ];

      const smsAmount = this.toCurrencyShort(metadata.smsUnitAmount);

      const texts = [
        `quota: ${metadata.quota}`,
        `renews each ${metadata.quotaRenewal}`,
        `SMS unit cost: ${smsAmount}`,
      ];

      const result = [] as string[];

      Object.keys(values).forEach((i) => {
        if (values[i]) {
          result.push(texts[i]);
        }
      });

      if (result.length > 0) {
        return `(${result.join(', ')})`;
      }

      return '';
    },

    toCurrencyShort(value): string {
      if (typeof value !== 'number') {
        return value;
      }

      const dollars = (value / 100);

      const formatter = new Intl.NumberFormat('en-AU', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });

      return `${formatter.format(dollars)}`;
    },
  },
  computed: {
    hasNextPrices() {
      return (this.nextPointer !== undefined);
    },
    priceOptions() {
      return {
        active: !this.showInactive,
        next: this.nextPointer,
        subscriptionScheme: this.subscriptionSchemeOption,
      };
    },
  },
});
